angular
    .module('festzelt-os.documents.templates')
    .factory('archiveDocumentTemplate', [
        '$injector',
        ($injector) => new ArchiveDocumentTemplateWorkflow($injector)
    ]);

class ArchiveDocumentTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');

        this.level = 'highlight';
        this.order = 30;
        this.title = this.translate.instant('general.verbs.archive');
        this.icon = 'trash-alt';
        this.key = 'archive-document-template';
    }

    action(documentTemplate, vm) {
        return this.alert
            .animatedAlert(
                this.translate.instant('documents.workflows.template-details.archive.ask-to-archive.title'),
                this.translate.instant('documents.workflows.template-details.archive.ask-to-archive.content', {
                    template_title: documentTemplate.title
                }),
                'attention',
                {
                    confirmButtonText: this.translate.instant('general.verbs.archive'),
                    cancelButtonText: this.translate.instant('general.buttons.cancel'),
                    wait: true
                })
            .then(() => {
                return this.api
                    .put(`documents/templates/${documentTemplate.id}/archive`)
                    .then(
                        () => {
                            this.alert.hide();
                            vm._loadModel()
                                .then(() => {
                                    vm._prepareNavServiceStuff();
                                });
                            return this.alert.success(
                                this.translate.instant('general.alerts.archive_success.title'),
                                this.translate.instant('general.alerts.archive_success.content')
                            );
                        }
                    )
                    .catch(err => this.alert.handle(err));
            })
            .catch(
                err => this.alert.handle(err)
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/archive-template.js